import {
  AddContactToResourceTranslation,
  addContactToResourceTranslation,
} from '@/assets/locales/components/addContactToResource/addContactToResource.translation.pl.ts';
import {
  addNoteToResourceTranslation,
  AddNoteToResourceTranslation,
} from '@/assets/locales/components/addNoteToResource/addNoteToResource.translation.pl.ts';
import {
  addTaskToResourceTranslation,
  AddTaskToResourceTranslation,
} from '@/assets/locales/components/addTaskToResource/addTaskToResource.translation.pl.ts';
import {
  announcementsTranslation,
  AnnouncementsTranslation,
} from '@/assets/locales/components/announcements/announcements.translation.pl.ts';
import {
  BreadcrumbsTranslation,
  breadcrumbsTranslation,
} from '@/assets/locales/components/breadcrumbs/breadcrumbs.translation.pl.ts';
import {
  deleteDialogTranslation,
  DeleteDialogTranslation,
} from '@/assets/locales/components/deleteDialog/deleteDialog.translation.pl.ts';
import {
  dictionaryAvailabilityGridTranslation,
  DictionaryAvailabilityGridTranslation,
} from '@/assets/locales/components/dictionaryAvailabilityGrid/dictionaryAvailabilityGrid.translation.pl.ts';
import {
  filesTabComponentTranslation,
  FilesTabComponentTranslation,
} from '@/assets/locales/components/filesTab/filesTab.component.translation.pl.ts';
import {
  fileUploadTranslation,
  FileUploadTranslation,
} from '@/assets/locales/components/fileUpload/fileUpload.translation.pl.ts';
import {
  formTranslation,
  FormTranslation,
} from '@/assets/locales/components/form/form.translation.pl.ts';
import {
  infoPanelTranslation,
  InfoPanelTranslation,
} from '@/assets/locales/components/infoPanel/infoPanel.translation.pl.ts';
import {
  permissionMatrixTranslation,
  PermissionMatrixTranslation,
} from '@/assets/locales/components/permissionMatrix/permissionMatrix.translation.pl.ts';
import {
  resourceCalendarCreateCellTranslation,
  ResourceCalendarCreateCellTranslation,
} from '@/assets/locales/components/resourceCalendarCreateCell/resourceCalendarCreateCell.translation.pl.ts';
import {
  resourceCalendarDayGridTranslation,
  ResourceCalendarDayGridTranslation,
} from '@/assets/locales/components/resourceCalendarDayGrid/resourceCalendarDayGrid.translation.pl.ts';
import {
  resourceCalendarGanttTranslation,
  ResourceCalendarGanttTranslation,
} from '@/assets/locales/components/resourceCalendarGantt/resourceCalendarGantt.translation.pl.ts';
import {
  resourceCalendarMonthGridTranslation,
  ResourceCalendarMonthGridTranslation,
} from '@/assets/locales/components/resourceCalendarMonthGrid/resourceCalendarMonthGrid.translation.pl.ts';
import {
  resourceCalendarRecurringTranslation,
  ResourceCalendarRecurringTranslation,
} from '@/assets/locales/components/resourceCalendarRecurring/resourceCalendarRecurring.translation.pl.ts';
import {
  resourceCalendarWeekGridTranslation,
  ResourceCalendarWeekGridTranslation,
} from '@/assets/locales/components/resourceCalendarWeekGrid/resourceCalendarWeekGrid.translation.pl.ts';
import { TableTranslations } from '@/assets/locales/components/table/table.translations.en.ts';
import { tableTranslations } from '@/assets/locales/components/table/table.translations.pl';
import {
  timelineMessagesTranslations,
  TimelineMessagesTranslations,
} from '@/assets/locales/components/timelineMessages/timelineMessages.translations.pl.ts';
import {
  backButtonTranslation,
  BackButtonTranslation,
} from '@/assets/locales/components/ui/backButton/backButton.translation.pl.ts';
import {
  versionCheckerTranslations,
  VersionCheckerTranslations,
} from '@/assets/locales/components/versionChecker/versionChecker.translations.pl.ts';

import {
  addDictionaryEntryDialogTranslation,
  AddDictionaryEntryDialogTranslation,
} from './addDictionaryEntryDialog/addDictionaryEntryDialog.translation.pl';

export type ComponentsTranslation = {
  addContactToResource: AddContactToResourceTranslation;
  addDictionaryEntryDialog: AddDictionaryEntryDialogTranslation;
  addNoteToResource: AddNoteToResourceTranslation;
  addTaskToResource: AddTaskToResourceTranslation;
  announcements: AnnouncementsTranslation;
  backButton: BackButtonTranslation;
  breadcrumbs: BreadcrumbsTranslation;
  deleteDialog: DeleteDialogTranslation;
  dictionaryAvailabilityGrid: DictionaryAvailabilityGridTranslation;
  filesTab: FilesTabComponentTranslation;
  fileUpload: FileUploadTranslation;
  form: FormTranslation;
  infoPanel: InfoPanelTranslation;
  permissionMatrix: PermissionMatrixTranslation;
  resourceCalendarCreateCell: ResourceCalendarCreateCellTranslation;
  resourceCalendarDayGrid: ResourceCalendarDayGridTranslation;
  resourceCalendarGantt: ResourceCalendarGanttTranslation;
  resourceCalendarMonthGrid: ResourceCalendarMonthGridTranslation;
  resourceCalendarRecurring: ResourceCalendarRecurringTranslation;
  resourceCalendarWeekGrid: ResourceCalendarWeekGridTranslation;
  table: TableTranslations;
  timelineMessages: TimelineMessagesTranslations;
  versionChecker: VersionCheckerTranslations;
};

export const componentsTranslation: ComponentsTranslation = {
  addContactToResource: addContactToResourceTranslation,
  addDictionaryEntryDialog: addDictionaryEntryDialogTranslation,
  addNoteToResource: addNoteToResourceTranslation,
  addTaskToResource: addTaskToResourceTranslation,
  announcements: announcementsTranslation,
  backButton: backButtonTranslation,
  breadcrumbs: breadcrumbsTranslation,
  deleteDialog: deleteDialogTranslation,
  dictionaryAvailabilityGrid: dictionaryAvailabilityGridTranslation,
  filesTab: filesTabComponentTranslation,
  fileUpload: fileUploadTranslation,
  form: formTranslation,
  infoPanel: infoPanelTranslation,
  permissionMatrix: permissionMatrixTranslation,
  resourceCalendarCreateCell: resourceCalendarCreateCellTranslation,
  resourceCalendarDayGrid: resourceCalendarDayGridTranslation,
  resourceCalendarGantt: resourceCalendarGanttTranslation,
  resourceCalendarMonthGrid: resourceCalendarMonthGridTranslation,
  resourceCalendarRecurring: resourceCalendarRecurringTranslation,
  resourceCalendarWeekGrid: resourceCalendarWeekGridTranslation,
  table: tableTranslations,
  timelineMessages: timelineMessagesTranslations,
  versionChecker: versionCheckerTranslations,
};
